
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AO",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AO.vue